import React, { Component } from 'react';

export default class Score extends Component {
  static defaultProps = {
    className: '',
    style: {},
  };

  render() {
    const { className, style, children, ...props } = this.props;
    let display = 'X';
    if (children !== '0.0') {
      display = children;
    }
    return (
      <span className={`score-item ${className}`} style={style} {...props}>
        {display}
      </span>
    );
  }
}
